module.exports = __webpack_public_path__ + "static/media/step1.23037295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/step1.jpg
// module id = 769
// module chunks = 0